import { Message, Tab } from '@alifd/next';
import { Button, Input } from 'antd';
import React, { useEffect, useState } from 'react';

import client from '@/lib/feathers';

import BAButton from '../BAButton';
import Slider from '../Slider';
import styles from './index.module.scss';

// const arrDev = [
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '我的燈光全開',
//     '文字': '我的燈光全開',
//     'pc': 'EZ01',
//     '自身型態': '多重',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '參數': '燈光1:開啟,燈光2:開啟,燈光3:開啟,燈光4:開啟,燈光5:開啟,燈光6:開啟,燈光7:開啟,燈光8:開啟,燈光9:開啟,燈光10:開啟,燈光11:開啟,燈光12:開啟,燈光13:開啟,燈光14:開啟',
//     '分類': '燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光全關',
//     '文字': '燈光全關',
//     'pc': 'EZ01',
//     '自身型態': '多重',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '參數': '燈光1:關閉,燈光2:關閉,燈光3:關閉,燈光4:關閉,燈光5:關閉,燈光6:關閉,燈光7:關閉,燈光8:關閉,燈光9:關閉,燈光10:關閉,燈光11:關閉,燈光12:關閉,燈光13:關閉,燈光14:關閉,260OFF:開啟',
//     '分類': '燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光2',
//     '文字': '世泰桌燈',
//     '裝置型態': 'AM-210S',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 1,
//     'group': 1,
//     'id': 2,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '主管室',
//     '分類': '燈',
//     '語音裝置名稱': '總經理室的燈,主管燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光3',
//     '文字': '郭總桌燈',
//     '裝置型態': 'AM-210S',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 1,
//     'group': 1,
//     'id': 3,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '主管室',
//     '分類': '燈',
//     '語音裝置名稱': '總經理室的燈,主管燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光1',
//     '文字': '會計室燈',
//     '裝置型態': 'AM-210S',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 1,
//     'group': 1,
//     'id': 1,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '主管室',
//     '分類': '燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光4',
//     '文字': '磁吸燈',
//     '裝置型態': 'AM-210S',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 1,
//     'group': 1,
//     'id': 4,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '主管室',
//     '分類': '燈',
//     '語音裝置名稱': '總經理室的燈,主管燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光7',
//     '文字': '大門\n吸頂燈',
//     '裝置型態': 'AM-210S',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 1,
//     'group': 1,
//     'id': 7,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '開啟',
//     '開關': '關掉',
//     '房間': '門口',
//     '分類': '燈',
//     '裝置別稱': '大門線燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光5',
//     '文字': '大門\n崁燈',
//     '裝置型態': 'AM-210S',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 1,
//     'group': 1,
//     'id': 5,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '門口',
//     '分類': '燈',
//     '裝置別稱': '大門崁燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光8',
//     '文字': '玄關\n投射燈',
//     '裝置型態': 'AM-210S',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 1,
//     'group': 1,
//     'id': 8,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '辦公室',
//     '分類': '燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光13',
//     '文字': '辦公室\n桌燈(後)',
//     '裝置型態': 'AM-DIO',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 2,
//     'group': 1,
//     'id': 3,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '辦公室',
//     '分類': '燈',
//     '語音裝置名稱': '辦公區的燈,辦公室的燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光14',
//     '文字': '辦公室\n桌燈(中)',
//     '裝置型態': 'AM-DIO',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 2,
//     'group': 1,
//     'id': 4,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '辦公室',
//     '分類': '燈',
//     '語音裝置名稱': '辦公區的燈,辦公室的燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光12',
//     '文字': '辦公室\n桌燈(前)',
//     '裝置型態': 'AM-DIO',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 2,
//     'group': 1,
//     'id': 2,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '辦公室',
//     '分類': '燈',
//     '語音裝置名稱': '辦公區的燈,辦公室的燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光10',
//     '文字': '辦公室\n吸頂燈',
//     '裝置型態': 'AM-210S',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 1,
//     'group': 1,
//     'id': 10,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '辦公室',
//     '分類': '燈',
//     '語音裝置名稱': '辦公區的燈,辦公室的燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光6',
//     '文字': '機櫃\n走道燈',
//     '裝置型態': 'AM-210S',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 1,
//     'group': 1,
//     'id': 6,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '辦公室',
//     '分類': '燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光11',
//     '文字': '會議室\n走道燈',
//     '裝置型態': 'AM-DIO',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 2,
//     'group': 1,
//     'id': 1,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '房間': '辦公室',
//     '分類': '燈',
//     '語音裝置名稱': '會議室的燈'
//   },
//   {
//     '裝置頁面': '燈光',
//     '裝置名稱': '燈光9',
//     '文字': '廁所燈',
//     '裝置型態': 'AM-210S',
//     'pc': 'EZ01',
//     'port': 14,
//     'addr': 1,
//     'group': 1,
//     'id': 9,
//     '自身型態': '開關',
//     '裝置外觀': '按鈕',
//     '狀態': '關閉',
//     '開關': '關掉',
//     '保留': 1,
//     '房間': '廁所',
//     '分類': '燈'
//   },
//   {
//     "_id": "60f91fc179170d0a4540886b",
//     "baId": "ezconba01_00:0C:29:01:98:27",
//     "baToken": "secrettoken",
//     "baDes": "易控BA主機",
//     "baIp": "10.1.1.3",
//     "baUrl": "/ezcon/api/pro",
//     "name": "Light1",
//     "text": "一樓走廊燈光1",
//     "group": "一樓燈光",
//     "type": "int",
//     "value": 0
//   },
//   {
//     "_id": "60f91fc179170d0a4540886c",
//     "baId": "ezconba01_00:0C:29:01:98:27",
//     "baToken": "secrettoken",
//     "baDes": "易控BA主機",
//     "baIp": "10.1.1.3",
//     "baUrl": "/ezcon/api/pro",
//     "name": "Light2",
//     "text": "一樓走廊燈光",
//     "group": "一樓燈光2",
//     "type": "int",
//     "value": 0
//   },
//   {
//     "_id": "60f91fc179170d0a4540886d",
//     "baId": "ezconba01_00:0C:29:01:98:27",
//     "baToken": "secrettoken",
//     "baDes": "易控BA主機",
//     "baIp": "10.1.1.3",
//     "baUrl": "/ezcon/api/pro",
//     "name": "Door1",
//     "text": "一樓大門門禁1",
//     "group": "一樓大門",
//     "type": "boolean",
//     "category": "門禁",
//     "value": true
//   },
//   {
//     "_id": "60f91fc179170d0a4540886e",
//     "baId": "ezconba01_00:0C:29:01:98:27",
//     "baToken": "secrettoken",
//     "baDes": "易控BA主機",
//     "baIp": "10.1.1.3",
//     "baUrl": "/ezcon/api/pro",
//     "name": "Door2",
//     "text": "一樓大門門禁2",
//     "group": "一樓大門",
//     "type": "boolean",
//     "category": "門禁",
//     "value": true
//   },
//   {
//     "_id": "60f91fc179170d0a4540886f",
//     "baId": "ezconba01_00:0C:29:01:98:27",
//     "baToken": "secrettoken",
//     "baDes": "易控BA主機",
//     "baIp": "10.1.1.3",
//     "baUrl": "/ezcon/api/pro",
//     "name": "Elevator1",
//     "text": "A棟電梯1",
//     "group": "A棟電梯",
//     "type": "boolean",
//     "category": "電梯",
//     "value": true
//   },
//   {"_id":"60f91fc179170d0a45408870",
//   "baId":"ezconba01_00:0C:29:01:98:27",
//   "baToken":"secrettoken",
//   "baDes":"易控BA主機",
//   "baIp":"10.1.1.3",
//   "baUrl":"/ezcon/api/pro",
//   "name":"Elevator2",
//   "text":"A棟電梯2",
//   "group":"A棟電梯",
//   "type":"boolean",
//   "category":"電梯",
//   "value":true
// }

// ]
function BAList() {
  const baDevice = client.service('baDevice');
  const communityData = client.service('communityData');
  const [arrDiv, setArrDiv] = useState([]);
  const [groupDataArr, setGroupDataArr] = useState(['全部']);
  const [selectTabName, setSelectTabName] = useState('');
  const [rangeValue, setRangeValue] = useState(0);
  const [communityArr, setCommunityArr] = useState({});
  const [communityStatus, setCommunityStatus] = useState(false);
  const [newBAUrl, setNewBAUrl] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);

  const detachedContentStyle = {
    border: '1px solid #DCDEE3',
    padding: '20px',
  };
  // console.log("groupDataArr",groupDataArr)

  const onChangeSlider = (e) => {
    setRangeValue(parseInt(e.target.value, 0));
  };

  function updateMultiState(arr) {
    // arr:[socket更新的data] || [find All的data]
    console.log(
      '==原baDeviceArr:',
      arr.map((x) => `${x.text}:${x.value}`).join(',')
    );

    setArrDiv((prevState) => {
      let finalArr = [];
      if (prevState.length === 0 && arr.length > 0) {
        // [find All的data]
        finalArr = arr;
      } else {
        // [socket更新的data]
        prevState = [...prevState].map((i) => i.props.item);
        const tarNames = [...arr].map((i) => i.name || false);
        finalArr = [...prevState].map((i) => {
          if (i.name && tarNames.includes(i.name)) {
            const tarChildNb = tarNames.indexOf(i.name);
            return {
              ...i,
              ...arr[tarChildNb],
            };
          }
          return i;
        });
      }
      return finalArr
        .filter((x) => x.sync !== 0)
        .map((x) => {
          if (isNaN(parseInt(x.value, 10))) {
            return <BAButton key={x._id} item={x} sync={x.sync} />;
          }
          // parseInt("開啟")=NaN
          else {
            return (
              <Slider
                key={x._id}
                item={x}
                min={0}
                max={100}
                step={1}
                defaultLength={x.value}
                value={x.value}
                sync={x.sync}
                onChangeValue={onChangeSlider}
                linearGradientColor="#4aa1f3"
                rangeBackgroundColor="#d7dcdf"
                sliderThumbColor="#4aa1f3"
              />
            );
          }
        });
    });
  }
  function renderNewArr() {
    if (selectTabName == '') return arrDiv;
    return [...arrDiv].filter((x) => {
      if (!x.props.item.tableGroup) return false; // 回傳過濾沒有Group key
      return x.props.item.tableGroup === selectTabName;
    });
  }

  useEffect(() => {
    baDevice
      .find({
        query: {
          securityIp: { $exists: false },
        },
      })
      .then((result) => {
        // console.log("result", result.data)
        // call getallstate?
        setGroupDataArr((groupDataArr) => [
          ...new Set(groupDataArr.concat(result.data.map((x) => x.tableGroup))),
        ]);
        updateMultiState(result.data); // 暫時處理
      })
      .catch((error) => {
        console.log('==原baDeviceArr:', error);
      });

    client.io.on('updatemultistate', (arr) => {
      console.log(
        'updatemultistate msg:',
        arr.map((x) => `${x.text}:${x.value}`).join(',')
      );
      updateMultiState(arr);
    });
    // client.reAuthenticate().then((data) => {
    //   console.log('==relogin ok', data.user.email);
    // }).catch(err => {
    //   console.log('==relogin fail');
    //   // history.push('/user/login');
    // })
    communityData.find({}).then((result) => {
      setCommunityArr(result.data[0]);
      setNewBAUrl(result.data[0]?.BAUrl ? result.data[0].BAUrl : '');
    });
  }, [isUpdate]);
  //   useEffect(() => {
  //     setArrDiv(arrDev.map(x=><BAButton item={x}></BAButton>))
  //   },[arrDev]);

  return (
    <>
      <Tab
        className={styles.tab}
        // lazyLoad={false}
        shape="pure"
        contentStyle={detachedContentStyle}
        onChange={(key) => {
          if (groupDataArr[key] === '全部') {
            setSelectTabName('');
          } else {
            setSelectTabName(groupDataArr[key]);
          }
        }}
      >
        {groupDataArr.map((item, index) => (
          <Tab.Item title={item} key={index}>
            <div className={styles.BAList}>{renderNewArr()}</div>
          </Tab.Item>
        ))}
      </Tab>
      <div>
        BA外部網址：
        {communityStatus ? (
          <Input
            value={newBAUrl}
            onChange={(event) => {
              setNewBAUrl(event.target.value);
            }}
          />
        ) : (
          <p>
            {communityArr?.BAUrl ? (
              <a href={communityArr.BAUrl} target="_blank">
                前往BA頁面
              </a>
            ) : (
              '無設定'
            )}
          </p>
        )}
        {communityStatus ? (
          <Button
            onClick={() => {
              const data = {
                ...communityArr,
                BAUrl: newBAUrl,
              };
              communityData.patch(communityArr._id, data).then(() => {
                Message.success('修改成功');
                setCommunityStatus(false);
                setIsUpdate((pre) => !pre);
              });
            }}
          >
            確定
          </Button>
        ) : (
          <Button
            onClick={() => {
              setCommunityStatus(true);
              setNewBAUrl(communityArr?.BAUrl);
            }}
          >
            編輯
          </Button>
        )}
      </div>
    </>
  );
}

export default BAList;
